import Phaser from "phaser";
import LoadingScene from "@/games/Fishing-2/scenes/LoadingScene";
import QuestionScene from "@/games/Fishing-2/scenes/QuestionScene";
import BeforeQuestionScene from "@/games/Fishing-2/scenes/BeforeQuestionScene";
import AfterQuestionScene from "@/games/Fishing-2/scenes/AfterQuestionScene";
import BossScene from "@/games/Fishing-2/scenes/BossScene";
import LandingScene from "@/games/Fishing-2/scenes/LandingScene";
import Settings from "@/games/Fishing-2/scenes/Settings";
import Recommendation from "@/games/Fishing-2/scenes/Recommendation";


function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      BeforeQuestionScene,
      AfterQuestionScene,
      BossScene,
      Settings,
      Recommendation,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
